export const en = {
  add_subtitle: 'Add Subtitle',
  add_title: 'Add Title',
  add_report_name: 'Add Report Name',
  view_report_history: 'view report history',
  add_detailed_report: 'add detailed report',
  edit_report_schedule: 'edit report schedule',
  download_csv_report: 'download csv report',
  download_fast_report: 'download fast report',
  add_template: 'Add Template',
  reports: 'Reports',
  report: 'Report',
  hashtag_templates: 'Hashtag Templates',
  hashtags_templates: 'Hashtag Templates',
  video_templates: 'Video Templates',
  videos_templates: 'Videos Templates',
  influencers_templates: 'Influencers Templates',
  news_templates: 'News Templates',
  tweets_templates: 'Tweets Templates',
  posts_templates: 'Posts Templates',
  instagram_templates: 'Instagram Templates',
  tiktok_templates: 'Tiktok Templates',
  clone: 'Copy',
  template: 'Template',
  template_details: 'Template Details',
  search_by_template: 'Search by Template Name',
  report_name: 'Report Name',
  template_name: 'Template Name',
  downloads: 'Downloads',
  active: 'Active',
  deactive: 'Deactive',
  download: 'download',
  create_report: 'add new report',
  edit_report: 'edit report',
  report_information: 'report information',
  add_comments: 'add comments',
  schedule_report: 'Schedule Report',
  search: 'search',
  report_template: 'Report template',
  report_description: 'report description',
  section: 'section',
  title: 'title',
  description: 'Write your Description here',
  email_body: 'Email body',
  add_field: 'add field',
  hashtags_reports: 'hashtag reports',
  schedule_status: 'Schedule Status',
  email_title: 'Email Title',
  email_interval: 'Email Interval',
  day_of_week: 'Day Of Week',
  time_zone: 'Time Zone',
  format: 'Format',
  send_to: 'Send To',
  sent_to: 'Sent To',
  version: 'Version',
  versions: 'versions',
  report_version: 'Report Version',
  sent_on: 'Sent on',
  email_subject: 'email subject',
  recipients: 'recipients',
  write_your_comment_here: 'Write your comment here',
  comment: 'Comment',
  am: 'am',
  pm: 'pm',
  first_of_month: 'first of month',
  second_of_month: 'second of month',
  specific_date: 'specific date',
  sa: 'Saturday',
  su: 'Sunday',
  mo: 'Monday',
  tu: 'Tuesday',
  we: 'Wednesday',
  th: 'Thursday',
  fr: 'Friday',
  time: 'time',
  words: 'word',
  pdf: 'pdf',
  days: 'Days',
  weekly: 'weekly',
  monthly: 'monthly',
  day_of_month: 'day of month',
  days_of_Week: 'days of Week',
  intervals: 'intervals',
  HH: 'HH',
  MM: 'MM',
  select_report_template: 'Select Report Template',
  cancel: 'cancel',
  templates: 'Templates',
  report_templates: 'Report Templates',
  single: 'Single',
  compare: 'Compare',
  template_type: 'Template Type',
  template_struct: 'Template Structure',
  instagram: 'instagram',
  select_data: 'Select Data',
  template_data: 'Template Data',
  instagram_posts_templates: 'instagram Posts Templates',
  youtube_posts_templates: 'youtube Posts Templates',
  youtube_posts: 'youtube posts',
  tiktok_posts_templates: 'tiktok Posts Templates',
  linkedin_posts_templates: 'linkedin Posts Templates',
  template_note:
    ' Note : here you can create the structure of the template where you can',
  template_information: 'Template information',
  add_pragh: 'Add Paragraph',
  report_history: 'Report History',
  tiktok: 'tiktok',
  report_added: 'report added successfully',
  report_update: 'Edit done Successfully',
  are_you_deactivate_this_hashtag_reports:
    'Are you sure you want to deactivate this hashtag reports?',
  template_edit: 'Template was edited successfully',
  template_add: 'Template was added successfully',
  change_template_type:
    'all of the selected structure will be removed are you sure?',
  template_add_des: 'Paragraph description',
  create_template: 'Create Template',
  edit_template: 'Edit Template',
  clone_template: 'Cloning Template',
  cancel_add_temp: 'Are you sure you want to cancel adding template?',
  cancel_edit_temp: 'Are you sure you want to cancel editing template?',
  cancel_clone_temp: 'Are you sure you want to cancel cloning template?',
  min_err_2: 'Must contain at least 2 characters',
  sections: 'sections',
  all_report_deactivated: 'All Reports Deactivated Successfully',
  verify_selected_slugs:
    'you must pick at least one component in template structure ',
  on_state: 'On',
  off_state: 'Off',
  active_state: 'Active',
  deactive_state: 'Deactive',
  trashed_temp: 'This template is trashed, Do you want to restore it?',
  arabic: 'Arabic',
  english: 'English',
  original: 'Original Language',
  original_lang: 'Original Language',
  search_by_report: 'Search by Report Name',
  tweets_types: 'Sorting',
  instagram_item: 'Posts',
  comments_item:'comment',
  replies_item:'replies',
  tiktok_item: 'Videos',
  posts_instagram_item: 'Posts',
  posts_linkedin_item: 'Posts',
  posts_youtube_item: 'Posts',
  tweets_item: 'tweet',
  tweets_number: 'Tweets Number',
  mandorty_lang: 'must pick at least one language',
  Template_preview: 'Template preview',
  confirm: 'confirm',
  data_from: 'Schedule Starting From',
  report_active: 'report activated Successfully',
  are_you_sure_you_want_to_cancel_edit_report:
    'Are you sure you want to cancel editing report?',
  are_you_sure_you_want_to_cancel_add_report:
    'Are you sure you want to cancel adding report?',
  entities_templates: 'entities templates',
  select: 'Select',
  daily: 'daily',
  CC: 'CC',
  BCC: 'BCC',
  only_show_latest: 'Only show latest',
  since_last_version: 'since last version',
  sub_title: 'Sub Title',
  report_summary: 'Report summary',
  section_title: 'section title',
  section_description: 'section description',
  report_title: 'Report Title',
  report_sub_title: 'report Sub-Title',
  report_data: 'Report Data',
  paragraph: 'paragraph',
  version_type: 'Version type',
  download_Detailed_Report: 'Download detailed report',
  select_report: 'Select report',
  report_type: 'report type',
  working_on_downloading_you_will_be_notified_once_finished:
    'Working on downloading ({{report_name}} with template {{template_name}} ) you will be notified once finished',
  twitter: 'twitter',
  tweets_classification: 'Tweets Classification ',
  tweets_type: 'Tweets Type',
  sorting: 'Sorting Type',
  display_format: 'display format',
  table_view: 'table view',
  youtube: 'youtube',
  author: 'author',
  articles_number: 'Articles Number',
  twitter_item: 'tweets',
  youtube_item: 'videos',
  author_item: 'articles',
  influencer_item: 'Influencers',
  entity_item: 'Entities',
  chart_desc: 'Charts Description',
  influencers_details_last_version:
    'Only show latest influencers details since last version',
  duplicate_input: 'This Combination of options already exists in the template',
  page_breaker: 'Page Breaker',
  add_clone_of_template: 'Are you want add clone for this template ?',
  cancel_clone_of_template: 'Are you sure you want to cancel cloning template?',
  group: 'Group',
  pragh: 'Description',
  platforms_data: 'Platforms data',
  about_to_download_report_influencer: ` You're about to download the report with the current influencer data. If you want to Regrab the influencer before downloading, please select the checkbox below.`,
  about_to_download_report_hashtag: ` You're about to download the report with the current hashtag data. If you want to Regrab the hashtag before downloading, please select the checkbox below.`,
  about_to_download_report_entity: ` You're about to download the report with the current entity data. If you want to Regrab the entity before downloading, please select the checkbox below.`,
  influencer: 'Influencer',
  template_type_error: 'you should select at least one ',
  posts_type: 'posts type',
  linkedin_item: 'posts',
  linkedin: 'linkedin',
};

export const ar = {
  linkedin: 'لينكدان',

  linkedin_item: 'المنشورات',
  posts_type: 'نوع المنشورات',
  template_type_error: 'يجب ان تختار واحد علي الأقل',
  influencer: 'مؤثر',
  about_to_download_report_influencer:
    'انت على وشك تحميل التقرير بالنسخة الحالية للمؤثر, إذا كنت تريد إعادة جلب المؤثر قبل التحميل قم باختيار خانة الاختيار أدناه',
  about_to_download_report_hashtag:
    'انت على وشك تحميل التقرير بالنسخة الحالية للهاشتاق, إذا كنت تريد إعادة جلب الهاشتاق قبل التحميل قم باختيار خانة الاختيار أدناه',
  about_to_download_report_entity:
    'انت على وشك تحميل التقرير بالنسخة الحالية للكيان, إذا كنت تريد إعادة جلب الكيان قبل التحميل قم باختيار خانة الاختيار أدناه',
  influencer_item: 'مؤثر ',
  entity_item: 'كيانات',
  tweets_item: 'تغريدة',
  group: 'مجموعه',
  add_clone_of_template: 'هل تريد اضافه نسخه من هذا القالب ؟',
  cancel_clone_of_template: 'هل انت متاكد من انك تريد الغاء نسخ هذا القالب ؟',
  twitter_item: 'التغريدات',
  youtube_item: 'الفيديوهات',
  author_item: 'المقالات',
  twitter: 'تويتر',
  youtube: 'يوتيوب',
  author: 'مؤلف',
  articles_number: 'عدد المقالات',
  add_subtitle: 'اضف عنوان فرعي',
  add_title: 'اضف عنوان رئيسي',
  add_report_name: 'اضف اسم التقرير',
  only_show_latest: 'فقط اعرض اخر',
  since_last_version: 'منذ اخر اصدار',
  daily: 'يومياً',
  confirm: 'تأكيد',
  min_err_2: 'يجب ألا يقل عدد الحروف عن 2',
  Template_preview: 'عرض القالب',
  tiktok: 'تيك توك',
  entities_templates: 'قوالب الكيانات',
  all_report_deactivated: 'تم ايقاف جميع التقارير',
  report_templates: 'قوالب التقرير ',
  cancel: 'إلغاء',
  select_report_template: 'حدد قالب التقرير',
  am: 'صباحاً',
  pm: 'مساءً',
  first_of_month: 'أول الشهر',
  instagram_item: 'المنشورات',
  tiktok_item: 'الفيديوهات',
  posts_instagram_item: 'المنشورات',
  posts_linkedin_item: 'المنشورات',
  posts_youtube_item: 'المنشورات',
  posts_templates: 'قوالب المنشورات',
  instagram_templates: 'قوالب انستغرام',
  tiktok_templates: 'قوالب التيك توك',
  second_of_month: 'الثاني من الشهر',
  specific_date: ' تاريخ مُحدد',
  sa: 'السبت',
  su: 'الأحد',
  mo: 'الإثنين',
  tu: 'الثُلاثاء',
  we: 'الأربعاء',
  th: 'الخميس',
  fr: 'الجُمعة',
  time: 'الوقت',
  words: 'مستند',
  pdf: 'pdf',
  days: 'أيام',
  weekly: 'أُسبوعياً',
  monthly: 'شهرياً',
  day_of_month: 'يوم من الشهر',
  days_of_Week: 'ايام الاسبوع',
  intervals: 'الفترات',
  HH: 'س',
  MM: 'د',
  select_data: 'تحديد البيانات',
  templates: 'قوالب',
  recipients: 'المُتَلَقين',
  email_subject: 'موضوع البريد الإلكتروني',
  sent_on: 'أرسل فى',
  report_version: 'نسخة التقرير',
  version: 'إصدار',
  versions: 'اصدارات',
  sent_to: 'أرسل إلى',
  send_to: 'المُرسل اليه',
  version_type: 'نوع الإصدار',
  email_title: 'عنوان البريد الالكترونى',
  template_name: 'اسم القالب',
  view_report_history: 'عرض سجل التقرير',
  add_detailed_report: 'إضافة تقرير مُفصل',
  edit_report_schedule: 'تعديل جدول التقرير',
  download_csv_report: 'تحميل تقرير CSV',
  download_fast_report: 'تحميل تقرير سريع',
  add_template: 'اضافة قالب',
  instagram_posts_templates: 'قوالب منشورات انستغرام',
  instagram_posts_templates: 'قوالب منشورات اليوتيوب',
  tiktok_posts_templates: 'قوالب منشورات التيك توك',
  linkedin_posts_templates: 'قوالب منشورات لينكد ان',
  reports: 'التقارير',
  report: 'التقرير',
  hashtag_templates: 'قوالب الهاشتاق',
  hashtags_templates: 'قوالب الهاشتاق',
  video_templates: 'قوالب الفيديو',
  videos_templates: 'قوالب الفيديوهات',
  influencers_templates: 'قوالب المؤثرون',
  tweets_templates: 'قوالب التغريدات',
  news_templates: 'قوالب الأخبار',
  clone: 'نسخ',
  template: 'قالب',
  template_details: 'تفاصيل القالب',
  report_name: 'اسم التقرير',
  downloads: 'التنزيلات',
  instagram: 'انستقرام',
  active: 'تفعيل',
  active_state: 'مفعل',
  deactive_state: 'غير مفعل',
  on_state: 'مفعل',
  off_state: 'معطل',
  deactive: 'تعطيل',
  download: 'تنزيل',
  youtube_posts: 'منشورات البوتيوب',
  create_report: 'إنشاء تقرير',
  report_information: 'معلومات التقرير',
  add_comments: 'أضف تعليقات',
  schedule_report: 'تقرير الجدول',
  report_name: 'اسم التقرير',
  search: 'ابحث',
  report_template: 'نموذج التقرير',
  report_description: 'وصف التقرير',
  section: 'القسم',
  title: ' عنوان رئيسي',
  description: 'اكتب وصفك هنا',
  add_field: 'إضافة حقل',
  hashtags_reports: ' تقارير الهاشتاق',
  schedule_status: 'حالة الجدول',
  email_interval: 'الفاصل الزمني للبريد الإلكتروني',
  day_of_week: 'يوم من الأسبوع',
  time_zone: 'وحدة زمنية',
  format: 'صيغة',
  write_your_comment_here: 'أكتب تعليقك هنا',
  search_by_template: 'ابحث بأسم القالب',
  comment: 'تعليق',
  format: 'الصيغة',
  recipients: 'المُتَلَقين',
  email_subject: 'موضوع البريد الإلكتروني',
  single: 'فردي',
  compare: 'مقارنة',
  report_history: 'تاريخ التقرير',
  are_you_deactivate_this_hashtag_reports:
    'هل أنت متأكد أنك تريد ايقاف تقارير الهاشتاج؟',
  template_type: 'نوع القالب',
  template_struct: 'هيكل القالب',
  template_data: 'بيانات القالب',
  template_note: ' يمكن هنا انشاء بيانات القالب الخاص بك',
  template_information: ' معلومات  القالب',
  add_pragh: 'أضف فقرة',
  add_pragh: 'ادخل عبارة',
  comments_item:'تعليقات',
  replies_item:'ردود',
  report_added: 'تمت إضافة التقرير بنجاح',
  report_update: 'تم التعديل بنجاح',
  edit_report: 'تعديل التقرير',
  template_edit: 'تم تعديل القالب بنجاح',
  template_add: 'تم اضافه القالب بنجاح',
  change_template_type:
    'all of the selected structure will be removed are you sure?',
  change_template_type: 'سوف يتم محو هيكل بيانات القالب هل انت متاكد؟',
  template_add_des: 'ادخل عبارة',
  create_template: 'انشاء قالب',
  edit_template: 'تعديل القالب',
  clone_template: 'نسخ القالب',
  cancel_add_temp: 'هل أنت متأكد أنك تريد إلغاء إضافة القالب ?',
  cancel_edit_temp: 'هل أنت متأكد أنك تريد إلغاء تعديل القالب ?',
  cancel_clone_temp: 'هل أنت متأكد أنك تريد إلغاء نسخ القالب ?',
  sections: 'قسم',
  verify_selected_slugs: 'يجب اختيار عنصر واحد علي الاقل في هيكل النموذج',
  trashed_temp: 'هذا القالب في المحذوفات ، هل تريد استعادته ؟',
  arabic: 'العربية',
  english: 'الانجليزية',
  original_lang: 'اللغة الأصلية',
  original: 'اللغة الأصلية',
  search_by_report: 'ابحث بأسم التقرير',
  tweets_types: 'ترتيب ',
  tweets_number: 'عدد التغريدات',
  mandorty_lang: 'يجب علي الاقل اختيار لغه واحده',
  data_from: 'تاريخ البداية',
  report_active: 'تم تنشيط التقرير بنجاح',
  email_body: 'نص البريد الإلكتروني',
  are_you_sure_you_want_to_cancel_edit_report:
    'هل انت متأكد انك تريد الغاء تعديل  التقرير؟',
  are_you_sure_you_want_to_cancel_add_report:
    'هل أنت متأكد من أنك تريد إلغاء إضافة تقرير؟',
  select: 'اختر',
  CC: 'نسخة الي',
  BCC: 'نسخة مخفية الوجه',
  sub_title: 'عنوان فرعي',
  report_summary: 'ملخص التقرير',
  section_title: 'عنوان القسم',
  section_description: 'وصف القسم',
  report_title: 'عنوان التقرير',
  report_sub_title: 'عنوان التقرير الفرعي',
  report_data: 'بيانات التقرير',
  paragraph: 'فقرة',
  download_Detailed_Report: 'تحميل تقرير مفصل',
  select_report: 'إختر تقرير',
  report_type: 'نوع التقرير',
  working_on_downloading_you_will_be_notified_once_finished:
    'جاري العمل على التنزيل ({{report_name}} مع القالب {{template_name}}) سيتم إخطارك بمجرد الانتهاء',
  tweets_classification: 'تصنيف التغريدات',
  tweets_type: 'انواع التغريدات',
  sorting: 'نوع الترتيب',
  display_format: 'طريقة العرض',
  table_view: 'جدول',
  chart_desc: 'وصف المخطط',
  influencers_details_last_version: 'اظهر فقط اخر تفاصيل المؤثر منذ اخر اصدار',
  duplicate_input: 'هذا المزيج من الاختيارات موجود بالفعل فى القالب',
  page_breaker: 'صفحه جديده',
  pragh: 'عباره',
  platforms_data: 'بيانات المنصات',
};
